import styled from 'styled-components';
import { Input } from '@pearsontechnology/aero-components';
import { ModalContent as ModalContentComponent } from 'components/Modal';

export const ModalContent = styled(ModalContentComponent)`
  padding-top: 0px;
`;

export const Spacer = styled.div`
  height: 28px;
`;

export const InputWithoutErrorWarningIcon = styled.div`
  svg {
    display: none;
  }
`;

export const ImportFileDropZoneLabel = styled.label`
  font-size: 14px;
  font-weight: 600;
`;

export const StyledDiv = styled.div`
  position: absolute;
  right: 40px;
  transform: translateY(50%);
  top: 100px;
  color: ${(props) => props.theme['color.text.body']};
`;

export const StyledSpan = styled.span`
  ${(props) => props.hasError && `
    font-weight: 600;
    color: ${props.theme['color.red.text']};
  `}
`;

export const StyledInput = styled(Input)`
  padding-right: 65px;
  text-overflow: ellipsis;
`;